var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{class:_vm.classComputed,attrs:{"dark":_vm.dark,"dense":_vm.dense,"hide-details":_vm.hideDetails,"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.label))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }